export const EGD_DOC_TYPE = 'egd';
export const VDK_DOC_TYPE = 'vdk';
export const REFPADO_DOC_TYPE = 'refpado';
export const REFREGA_DOC_TYPE = 'refrega';
export const REFREGD_DOC_TYPE = 'refregd';
export const REFREGF_DOC_TYPE = 'refregf';
export const FLSCOPY_DOC_TYPE = 'flscopy';
export const REFPASS_DOC_TYPE = 'refpass';
export const REFDEBT_DOC_TYPE = 'refdebt';
export const HOUSEBOOK_DOC_TYPE = 'housebook';
export const FLSEGD_DOC_TYPE = 'flsegd';
export const FLSOBORVED_DOC_TYPE = 'flsoborved';

export const NOT_FOUND_DOC_TYPE = '404';
